import { BackgroundVideo,BackgroundVideoProps } from ".";
import React from "react";
import { ComponentInterfaceBaseClass } from "@att-bit/duc.utils-ts.types";
import { IUseWindowSize } from "@att-bit/duc.hooks.use-window-size";


export class BackgroundVideoInterface
  extends ComponentInterfaceBaseClass
  implements BackgroundVideoProps
{
  id: string;
  modal?: boolean;
  isScroll?: boolean;
  cinema?: boolean;
  autoplay?: boolean;
  autoPlayPause?: boolean;
  autoPlayLoop?: boolean;
  overlayTextDisplayAtEnd?: boolean;
  showTime?: boolean;
  showTitle?: boolean;
  videoStyles?: {height?:string, width?: string};
  autoReduceSize?: boolean;
  viewport?: IUseWindowSize;
  playerView?: boolean;
  parentCallback? : any;
  opacity?: string;
  gvpPlayerAccessibilityText?: string;  
  radius?: boolean;
  unconstrained?: boolean;
  viewportPause?: boolean;

  static initWithSanity(key, feed) {
    const t = new BackgroundVideoInterface();
    t.id = feed?.videoId;
    t.modal = feed?.modal;
    t.isScroll = feed?.isScroll;
    t.cinema = feed?.cinema;
    t.autoplay = feed?.autoplay;
    t.autoPlayLoop = feed?.autoPlayLoop;
    t.autoPlayPause = feed?.autoPlayPause;
    t.overlayTextDisplayAtEnd = feed?.overlayTextDisplayAtEnd;
    t.showTime = feed?.showTime;
    t.showTitle = feed?.showTitle;
    t.videoStyles = feed?.videoStyles;
    t.autoReduceSize = feed?.autoReduceSize;
    t.viewport = feed?.viewport;
    t.playerView = feed?.playerView;
    t.opacity = feed?.opacity;
    t.gvpPlayerAccessibilityText = feed?.gvpPlayerAccessibilityText;
    t.radius = feed?.radius;
    t.unconstrained = feed?.unconstrained ;
    t.viewportPause = feed?.viewportPause;
    return t;
  }

  toProps({ id = undefined, viewport = undefined } = {}): BackgroundVideoProps {
    const props = {
      id: id || this.id,
      modal: this.modal,
      isScroll: this.isScroll,
      cinema: this.cinema,
      autoplay: this.autoplay,
      autoPlayPause: this.autoPlayPause,
      autoPlayLoop: this.autoPlayLoop,
      overlayTextDisplayAtEnd: this.overlayTextDisplayAtEnd,
      showTime: this.showTime,
      showTitle: this.showTitle,
      videoStyles: this.videoStyles,
      autoReduceSize: this.autoReduceSize,
      viewport: this.viewport,
      playerView: this.playerView,
      parentCallback: this.parentCallback,
      opacity: this.opacity,
      gvpPlayerAccessibilityText: this.gvpPlayerAccessibilityText,
      unconstrained: this.unconstrained,
      viewportPause: this.viewportPause
    };
    return props;
  }

  toJsx({
    id = undefined,
    viewport = undefined
  } = {}): JSX.Element {
    return React.createElement(BackgroundVideo, {
      id: id || this.id,
      viewport,
      ...this.toProps({ id, viewport}),
    });
  }


}
